module.exports = __webpack_public_path__ + "img/collaborate_16.510d6dfe.jpg";